import parse from "html-react-parser"
import { useState } from "react"

import iconCheck from "images/icons/checkmark.svg?raw"

import type { CheckboxMultiData, UIEvent } from "../types"
import { CardActions, CardButton, CardShell } from "./card_shell"
import styles from "./checkbox_multi_card.module.scss"

interface Props {
  ui: UIEvent
  onRespond: (uiId: string, actionId: string, value: unknown, displayText?: string) => void
}

const CheckboxMultiCard = ({ ui, onRespond }: Props) => {
  const [answered, setAnswered] = useState(false)
  const [selected, setSelected] = useState<Set<string>>(new Set())

  const { prompt, options } = ui.data as CheckboxMultiData

  const toggle = (value: string) => {
    if (answered) return
    setSelected(prev => {
      const next = new Set(prev)
      if (next.has(value)) next.delete(value)
      else next.add(value)
      return next
    })
  }

  const submit = () => {
    if (answered) return
    setAnswered(true)
    const chosen = options.filter(option => selected.has(option.value))
    const values = chosen.map(option => option.value)
    const displayText = chosen.length > 0 ? chosen.map(option => option.label).join(", ") : "None of those"
    onRespond(ui.id, "select", { type: "multi_select", values }, displayText)
  }

  return (
    <CardShell prompt={prompt} onDismiss={() => onRespond(ui.id, "close", undefined)}>
      <ul className={styles["grid"]}>
        {options.map(option => (
          <li key={option.value}>
            <label className={styles["option"]}>
              <span className={styles["control"]}>
                <input
                  type="checkbox"
                  className={styles["input"]}
                  checked={selected.has(option.value)}
                  disabled={answered}
                  onChange={() => toggle(option.value)}
                />
                <span className={styles["box"]} aria-hidden="true">
                  {parse(iconCheck)}
                </span>
              </span>
              <span className={styles["label"]}>{option.label}</span>
            </label>
          </li>
        ))}
      </ul>
      <CardActions>
        <CardButton variant="primary" disabled={answered} onClick={submit}>
          Select
        </CardButton>
      </CardActions>
    </CardShell>
  )
}

export default CheckboxMultiCard
